
import { Button } from "@/components/ui/button";
import { Loader2, Upload } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { updatePixelScript, PixelScriptMetadata } from "../../UpdatePixelScript";

interface AdminControlsProps {
  isAdmin: boolean | undefined;
  onScriptUpdate: (metadata: PixelScriptMetadata) => void;
}

export function AdminControls({ isAdmin, onScriptUpdate }: AdminControlsProps) {
  const [updating, setUpdating] = useState(false);

  if (!isAdmin) return null;

  const handleUpdateScript = async () => {
    console.log("Update script button clicked");
    setUpdating(true);
    try {
      console.log("Calling updatePixelScript function");
      const metadata = await updatePixelScript();
      console.log("Script update successful, metadata:", metadata);
      onScriptUpdate(metadata);
      toast.success("Script updated successfully");
    } catch (error) {
      console.error("Failed to update script:", error);
      toast.error("Failed to update script: " + (error instanceof Error ? error.message : "Unknown error"));
    } finally {
      setUpdating(false);
      console.log("Script update process completed");
    }
  };

  return (
    <Button
      type="button"
      variant="outline"
      className="flex-1"
      onClick={handleUpdateScript}
      disabled={updating}
    >
      {updating ? (
        <>
          <Loader2 className="w-4 h-4 mr-2 animate-spin" />
          Updating...
        </>
      ) : (
        <>
          <Upload className="w-4 h-4 mr-2" />
          Update Script
        </>
      )}
    </Button>
  );
}
